import { Component, Inject,Input , Output, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ClientLoggerService } from '../../services/client-logger.service';
import _ from 'lodash';

import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { PerformanceContextService } from '../../services/performance-context.service';

import {AdminUser, PersonRole, ParnellEnum, PerformanceContext} from '../../interfaces/mysynch.interfaces'; 

interface MaintAdminUser{
    person:AdminUser | {}
    personRole:PersonRole | {}
}

@Component({
    standalone: false,
    selector: 'admin-user-management-maint',
    templateUrl: '../app/pages/admin-user-management-maint/admin-user-management-maint.view.html',
    styleUrls: ['../app/pages/admin-user-management-maint/admin-user-management-maint.style.css']
    })
export class AdminUserManagementMaint implements OnInit , OnDestroy{

    @ViewChild('adminUserForm') adminUserForm: NgForm;

    private defaultPersonTypeId:number = 6; // "Other"
	private updatePermissionCode:string = 'ADMIN_USER_MANAGEMENT_MAINT_UPDATE';
    private performanceContext: PerformanceContext | null = null;
    
    hasUpdatePermission:boolean = false;
    adminUser: MaintAdminUser = {
        person: {},
        personRole:{}
    }


    loading:	boolean = true;
    personRoles: ParnellEnum[] = [];
    personRoleStatuses: ParnellEnum[] = [];	
    isEditing:boolean = true;
    isSaving:boolean = false;
    _:any = _;

    // the person id of the admin user that we are editing , but will be undefined if we are adding a new new admin user
    personId: number | undefined = undefined; 
    tmRoleId: number = _.get(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'),'value');
    paRoleId: number = _.get(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'),'value');
    // need to keep track of the value of the roleId for the user to also update PersonTM MSF List if needed. 
    oldRoleId: number | undefined = undefined;
    
    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject(PerformanceMetricsService)private perfMetricSvc: PerformanceMetricsService, 
                @Inject(MySynchEnumerationService)private mySynchEnumSvc: MySynchEnumerationService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
               ) { 
                
               }

    ngOnInit() {
        this.MSF.ready(() => {
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
           this.personRoles =  _.filter(this.mySynchEnumSvc.getMySynchEnumerationItems('Role') as ParnellEnum[], (i) => {
                                    return _.includes(['SUPER_ADMIN', 'TERRITORY_MANAGER','PARNELL_VIEWER'], i.name);
                                 });
           this.personRoleStatuses =  _.reject(_.values(this.mySynchEnumSvc.getMySynchEnumerationItems("PersonRoleStatus")), {name: 'PENDING'});
           this.perfMetricSvc.startTiming("Page:AdminUserManagement:Render");
            // if farmId on state.params is an empty string then we are adding a new farm
            if(_.isNull(this.MSF.state.params.personId) || _.isEqual(this.MSF.state.params.personId,"")){
                this.isEditing = false;
            }else{
                this.personId = Number(this.MSF.state.params.personId);
            }
            
           this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
            this.loadReportData().then(()=>{
                this.loading = false;
                this.perfMetricSvc.markPageReady("Page:AdminUserManagement:Render", this.performanceContext);
            });
        });

    }

    ngOnDestroy() {
        
    }

    private buildMappedFieldsForLoad(){
					
        // building Territory from lastName field. 
        var adminUserLastName = _.get(this.adminUser,'person.lastName',"");
        var territoryStart = _.indexOf(adminUserLastName,"(");
        var territoryEnd = _.indexOf(adminUserLastName,")");

        if(territoryStart > -1 && territoryEnd > -1){
            var territory = adminUserLastName.substring(territoryStart + 1,territoryEnd); 
            _.set(this.adminUser,'person.territory',territory)
            
            var cleanedLastName = adminUserLastName.substring(0,territoryStart - 1);
            _.set(this.adminUser,'person.lastName',cleanedLastName);
        }		

    }

		
    private buildMappedFieldsForSave(){ 
        // building lastName field form territory 

        var adminUserLastName = _.get(this.adminUser,'person.lastName',"");
        var adminUserTerritory = _.get(this.adminUser,'person.territory',"");
        if(!_.isNull(adminUserTerritory) && !_.isEqual(adminUserTerritory,"")){
            // first strip any spaces and ( ) from Territory if the user included those to ensure 
            // proper format of last name				
            var cleanedAdminUserTerritory = _.trim(adminUserTerritory);
            cleanedAdminUserTerritory = cleanedAdminUserTerritory.replace("(","");
            cleanedAdminUserTerritory = cleanedAdminUserTerritory.replace(")","");

            var adminUserLastNameWithTerritory = adminUserLastName+" ("+cleanedAdminUserTerritory+")";
            
            _.set(this.adminUser,'person.lastName',adminUserLastNameWithTerritory);
        }

    }

    private loadReportData(){
        return new Promise<void>((resolve,reject) => {
            if(this.isEditing){
                this.perfMetricSvc.startTiming("Page:AdminUserManagementGetAdminUserById:Request");
                this.api.getAdminUserById(this.personId, this.performanceContext, (err: any, data: any) => {
                    this.perfMetricSvc.endTiming("page","Page:AdminUserManagementGetAdminUserById:Request", this.performanceContext);
                    if (err) {
                        this.log.error('unable to get admin user with Id of '+this.personId+': ' + err);
                
                        resolve();
                        return;
                    } 
                    this.perfMetricSvc.startTiming("Page:AdminUserManagement:Build");
                    this.adminUser = _.clone(data);
                    
                    this.oldRoleId = _.get(this.adminUser,'personRole.roleId');

                    this.buildMappedFieldsForLoad();

                    this.perfMetricSvc.endTiming("page","Page:AdminUserManagement:Build", this.performanceContext);
                   
                    resolve();

                });
            }else {
                resolve();
            }
        });

    }


    private createAdminUser() {
        if (!this.adminUserForm.form.valid) {
                this.adminUserForm.form.markAllAsTouched();
            return false;
        }

        this.isSaving = true;
        var createData = {
            person: "",
            personRole: ""
        }

        this.buildMappedFieldsForSave();

        _.set(createData,'person',JSON.stringify(this.adminUser.person));
        _.set(createData,'personRole',JSON.stringify(this.adminUser.personRole));

    
        this.log.info("creating admin user with the following data");
        this.log.info(createData);

        this.api.adminCreateAdminUser(createData, (err: any, newAdminUser: AdminUser) => {
            this.loading = false;

            if (err) {
                this.buildMappedFieldsForLoad();
                return this.log.error(this.MSF.notify.danger(err));
            }

                this.MSF.refreshStaticLists();
            
            

            this.log.info(this.MSF.notify.success('Admin User created successfully'));
            this.MSF.loadPage('AdminUserManagement');
        });
    };

    private updateAdminUser() {
				
        if (!this.adminUserForm.form.valid) {
                this.adminUserForm.form.markAllAsTouched();
            return false;
        }

        this.isSaving = true;

        
        var updateData : MaintAdminUser = {
            person: {},
            personRole: {}
        };


        this.buildMappedFieldsForSave();

        _.set(updateData,'person',JSON.stringify(this.adminUser.person));
        _.set(updateData,'personRole',JSON.stringify(this.adminUser.personRole));


        this.api.updateAdminUser(this.personId,updateData,(err: any, data: any) => {
            this.isSaving = false;
            if (err) {
                this.log.error(this.MSF.notify.danger(err));
                this.buildMappedFieldsForLoad();
                return;
            }


            this.MSF.refreshStaticLists();
            
            this.log.info(this.MSF.notify.success('Admin User update successfully'));
            this.MSF.loadPage('AdminUserManagement');
    
        });  

        
    };

			
    submit(){
        if(this.isEditing){
            this.updateAdminUser();
        }else{
            this.createAdminUser();
        }
    }
			
    cancel() {
        this.MSF.loadPage('AdminUserManagement');
    };

}